import type {
  Progress,
  CertificatesListItem,
} from '@openeducation/oe-rn-shared-types';

import { dateArrayToDate } from './date-utils';

export const prepareCertificatesListData = (
  progressData: Progress | undefined
): CertificatesListItem[] => {
  if (!progressData) return [];

  return Array.from({ length: progressData?.numLevels || 0 }).map((_, i) => {
    const levelNum: number = i + 1;
    const date = progressData?.certificates?.find(
      (cert) => +cert.level.levelNum === levelNum
    )?.creationdate;

    return {
      levelNum,
      completed: progressData.certificates.some(
        (certificate) => +certificate.level.levelNum === levelNum
      ),
      date: date ? dateArrayToDate(date) : null,
    };
  });
};
